import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import AddToMerchantsView from './AddToMerchantsView';

import { selectInstantCredit, Wallet } from 'state/instantCredit';
import useIdiSdk from 'hooks/useIdiSdk';

type PropTypes = RouterProps;

const AddToMerchants: React.FC<PropTypes> = () => {
  const { wallets } = useSelector(selectInstantCredit);
  const { pushProvision, inProgress } = useIdiSdk();
  const onChoice = useCallback(
    (wallet: Wallet) => {
      // sdk must already be initialized
      pushProvision(wallet);
    },
    [pushProvision],
  );

  return (
    <AddToMerchantsView
      inProgress={inProgress}
      onChoice={onChoice}
      wallets={(wallets && wallets.eligibleOnFileWallets) || []}
    />
  );
};

export default AddToMerchants;
